import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Table } from 'antd'

const B2becTable = ({
  className = null,
  boxShadow = false,
  striped = true,
  ...otherProps
}) => {
  const { t } = useTranslation()
  return (
    <Table
      {...otherProps}
      pagination={false}
      className={`base-table ${className} ${boxShadow ? 'box-shadow' : ''} ${
        striped ? 'striped' : ''
      }`}
      locale={{
        emptyText: t('noData'),
      }}
    />
  )
}

export default B2becTable
